(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.anya-header__mobile').forEach((menu) => {
    const trigger = menu.querySelector('summary');
    const closeMenu = () => {
      menu.removeAttribute('open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    menu.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    });

    menu.querySelector('[data-menu-close]')?.addEventListener('click', closeMenu);
    menu.querySelectorAll('nav a').forEach((link) => link.addEventListener('click', closeMenu));

    document.addEventListener('click', (event) => {
      if (menu.open && !menu.contains(event.target)) closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        closeMenu();
        trigger.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
